export default "__VITE_ASSET__DbTusTLH__"